<template>
    <div>
    <div class="mb-3 ex-blog">
       {{__('export.Export Title') }}
    </div>
        <!-- Loading -->
        <b-overlay :show="form.busy">

            <!-- Form -->
            <form @submit.prevent="submit" novalidate="true">
                <div class="row">
                    <div class="col-sm-6">
                        <!-- Field -->
                        <b-form-group :label="__('export.Start Date')">
                            <b-form-datepicker
                                v-model="form.start_date"
                                :class="{ 'is-invalid': form.errors.has('start_date') }"
                                placeholder="">
                            </b-form-datepicker>
                             <has-error :form="form" field="start_date"></has-error>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <!-- Field -->
                        <b-form-group :label="__('export.End Date')">
                            <b-form-datepicker
                                v-model="form.end_date"
                                :class="{ 'is-invalid': form.errors.has('end_date') }"
                                placeholder="">
                            </b-form-datepicker>
                            <has-error :form="form" field="end_date"></has-error>
                        </b-form-group>
                    </div>
                </div>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disabled="form.busy">
                    {{ __('Export') }}
                </b-button>

            </form>
        </b-overlay>
    </div>
</template>

<script>
import { Form } from 'vform'

export default {
    data() {
        return {
            loading: false,
            form: new Form({
                start_date: null,
                end_date: null,
            })
        }
    },
    methods: {
        submit() {
            this.form.post('export_bets')
                .then(response => {
                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "staketoys.xlsx");
                    document.body.appendChild(fileLink);

                    fileLink.click();
            })
            .catch(() => console.log('error occured'))
        },
    }
}
</script>

<style>

</style>

